import { FaFacebook, FaInstagram, FaYoutube, FaWhatsapp } from "react-icons/fa";
import { ImLocation } from "react-icons/im";
import { MdEmail } from "react-icons/md";
import { MdPhone } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { localePath } from "../i18n/config";

const iconStyle: React.CSSProperties = {
    borderRadius: "50%",
    border: "1.5px solid #4e5180",
    padding: "0.3rem",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#4e5180",
    flexShrink: 0,
};

const CopyrightPPLink = () => {
    const year = new Date().getFullYear();

    return (
        <div className="footer-bar">
            {/* Social icons */}
            <div className="footer-icons">
                <a href="https://www.facebook.com/digihappy/" target="_blank" rel="noreferrer" aria-label="Facebook">
                    <span style={iconStyle}><FaFacebook size={18} /></span>
                </a>
                <a href="https://www.instagram.com/digihappy.fi/" target="_blank" rel="noreferrer" aria-label="Instagram">
                    <span style={iconStyle}><FaInstagram size={18} /></span>
                </a>
                <a href="https://www.youtube.com/channel/UCgYFspvcO-scKkDss7hIYKw" target="_blank" rel="noreferrer" aria-label="YouTube">
                    <span style={iconStyle}><FaYoutube size={18} /></span>
                </a>
                <a href="https://maps.app.goo.gl/WS3huAxDCNpjWcM97" target="_blank" rel="noreferrer" aria-label="Location">
                    <span style={iconStyle}><ImLocation size={18} /></span>
                </a>
                <a href="mailto:digihappy@digihappy.fi" aria-label="Email">
                    <span style={iconStyle}><MdEmail size={18} /></span>
                </a>
            </div>

            {/* Contact info */}
            <span className="footer-text">digihappy@digihappy.fi</span>
            <span className="footer-text">
                <FaWhatsapp size={16} style={{ marginRight: "0.3rem", verticalAlign: "middle" }} />
                WhatsApp: +358 50 321 0100
            </span>
            <span className="footer-text">
                <MdPhone size={16} style={{ marginRight: "0.3rem", verticalAlign: "middle" }} />
                +358 10 517 2070
            </span>

            {/* Copyright */}
            <NavLink className="footer-copyright" to={localePath("palveluehdot")}>Copyright &copy; Digihappy {year}</NavLink>
        </div>
    );
};

export default CopyrightPPLink;
